import React from 'react';
import { useMarketLiquidity } from '../../hooks/useMarketLiquidityStore';
import { OrderbookProduct } from '../../hooks/useOrderbookData';
import { ProductType } from '../../hooks/useProducts';
import { BidsAsks } from '../../types/orderbook';
import { StandardOrderbookUi } from './layouts/StandardOrderbook';

export interface OrderbookUiProps {
  data?: BidsAsks;
  onRowClick: (price: bigint, amount: bigint) => void;
  product: OrderbookProduct;
  error?: string | null;
  rowCount: number;
}

export const Orderbook: React.FC<{
  product: ProductType;
  onRowClick: (price: bigint, amount: bigint) => void;
  rowCount: number;
  layout?: React.ComponentType<OrderbookUiProps>;
}> = ({ product, onRowClick, rowCount, layout: OrderbookComponent = StandardOrderbookUi }) => {
  const { liquidityData, error } = useMarketLiquidity(product.id);

  return (
    <div className="size-full">
      <OrderbookComponent
        product={product}
        data={liquidityData}
        onRowClick={onRowClick}
        error={error}
        rowCount={rowCount}
      />
    </div>
  );
};
